import { SidebarTrigger } from "~/components/ui/sidebar";
import { useAuthenticatedUser } from "~/hooks/useAuthenticatedUser";

export const TopNav = () => {
  const publicFacingDomain = import.meta.env.VITE_PUBLIC_URL || "https://qa.proudlyhuman.org";
  const { user } = useAuthenticatedUser();

  return (
    <header className="fixed top-0 z-50 w-full border-b bg-white shadow-sm">
      <div className="flex h-16 items-center justify-between px-6">
        {/* Left section with mobile menu and logo */}
        <div className="flex items-center gap-3">
          {/* Mobile menu button - only on small screens */}
          <SidebarTrigger className="md:hidden" />

          {/* Logo Section */}
          <a href={publicFacingDomain} className="flex items-center gap-2">
            <img
              src="/logo/flat/LOGO-BLACK.png"
              alt="ProudlyHuman™ Logo"
              className="h-8 w-auto object-contain"
            />
          </a>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground font-medium">
            {user?.firstName?.charAt(0).toUpperCase()}
          </div>
          <div className="grid text-left text-sm leading-tight">
            <span className="truncate font-semibold">
              {user?.firstName} {user?.lastName}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};
